import { ReactElement } from 'react';

import Delayed from '../Delayed';
import styles from './NoDataFound.module.scss';

interface IProps {
  title?: string;
  waitBeforeShow?: number;
}

const NoDataFound = ({ title = 'No data found', waitBeforeShow = 0 }: IProps): ReactElement => (
  <Delayed waitBeforeShow={waitBeforeShow}>
    <div className={styles.noDataFound}>{title}</div>
  </Delayed>
);

export default NoDataFound;
